import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export function Logo({ dark = false, className = "" }) {
  const textColor = dark ? "text-white" : "text-[#0A192F]";
  return (
    <Link to="/" data-testid="logo-link" className={`flex items-center gap-2 ${className}`}>
      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#10B981]">
        <ShieldCheck className="h-5 w-5 text-white" strokeWidth={2.4} />
      </span>
      <span className={`font-display text-xl font-extrabold tracking-tight ${textColor}`}>
        Vivi<span className="text-[#10B981]">Tranquillo</span>
      </span>
    </Link>
  );
}
